import { DefaultRequest } from 'scripts/api';

/* Model */
class AssignUnassignToRouteModel extends App.Models.BaseModel {
    urlAssignUnassign = "";

    assignToRouteInBatch = (options, successCallback, errorCallback, showAlert = true) => {
        let error = null;
        const list = options.list;

        if (list) {
            try {
                let saved = false;
                const request = new DefaultRequest({
                    url: `${this.urlAssignUnassign}/batch`,
                    method: 'post',
                    data: list,
                    success: function (data) {
                        if (successCallback) {
                            successCallback(data);
                        }
                    },
                    error: function (data) {
                        if (errorCallback) {
                            errorCallback(data);
                        }

                        if(!showAlert) return;

                        const mMessage = new Monet.Form.Messages.AlertMessage();
                        mMessage.setMessage(JSON.parse(data.responseText));
                        mMessage.triggerMessage();
                        saved = false;
                    }
                });
                request.send();
                return saved;
            } catch (e) {
                error = new Monet.Exception.ReturnError(this,
                    "No save drive to route.", e);
                error.console();
            }
        } else {
            error = new Monet.Exception.ReturnError(this,
                "No data to save drive.");
            error.console();
        }
    }

    assignToRoute = (options, successCallback, errorCallback) => {
      const list = options.list;

      if (list) {
          try {
              let saved = false;
              const request = new DefaultRequest({
                  url: this.urlAssignUnassign,
                  method: 'post',
                  data: list,
                  success: function (data) {
                      if (successCallback) {
                          successCallback(data);
                      }
                  },
                  error: function (data) {
                      if (errorCallback) {
                          errorCallback(data);
                      }
                      const mMessage = new Monet.Form.Messages.AlertMessage();
                      mMessage.setMessage(JSON.parse(data.responseText));
                      mMessage.triggerMessage();
                      saved = false;
                  }
              });
              request.send();
              return saved;
          } catch (e) {
              new Monet.Exception.ReturnError(this, "No save drive to route.", e)
                .console();
          }
      } else {
          new Monet.Exception.ReturnError(this, "No data to save drive.")
            .console();
      }
  }

    unassignToRoute = (options, successCallback, errorCallback) => {
        var removed = false,
            error = null,
            assignmentId = options.assignmentId;

        try {
            const request = new DefaultRequest({
                url: this.urlAssignUnassign + "/" + assignmentId,
                method: 'delete',
                success: function (data) {
                    removed = data;

                    if (successCallback) {
                        successCallback(data);
                    }
                },

                error: function (data) {
                    if (errorCallback) {
                        errorCallback(data);
                    }

                    var mMessage = new Monet.Form.Messages.AlertMessage();
                    mMessage.setMessage(JSON.parse(data.responseText));
                    mMessage.triggerMessage();
                }
            });
            request.send();
        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "No unassign drive.", e);
            error.console();
        }
        return removed;
    }

    unassignAllToRoute = (options, successCallback, errorCallback, showAlert = true) => {
        const assignmentsListId = options.assignmentsListId;

        try {
            const request = new DefaultRequest({
                url: `${this.urlAssignUnassign}/BatchDelete`,
                method: 'post',
                data: assignmentsListId,
                success: function (data) {
                    if (successCallback) {
                        successCallback(data);
                    }
                },
                error: function (data) {
                    if (errorCallback) {
                        errorCallback(data);
                    }

                    if(!showAlert) return;

                    var mMessage = new Monet.Form.Messages.AlertMessage();
                    mMessage.setMessage(JSON.parse(data.responseText));
                    mMessage.triggerMessage();
                }
            });
            request.send();

        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "No unassign drive.", e);
            error.console();

            errorCallback();
        }
    }
}

App.Models.AssignUnassignToRoute = AssignUnassignToRouteModel;
